import { Script } from 'gatsby';
import React, { type FC } from 'react';

// TODO: Przerobić skrypt na komponent Reactowy i pamiętać o UX (dostęp za pomocą klawiatury)
export const CookieConsentScript: FC = () => {
    if (process.env['NODE_ENV'] === 'development') {
        return;
    }

    return <Script strategy="idle" src="/assets/js/min/cookie-consent.js" />;
};
